import React from "react";
import { InputNumber } from "primereact/inputnumber";
import Field from "./Field";

const FreeSection: React.FC = () => (
  <div className="te-period te-free-period">
    <div className="te-period-header">
      <i className="pi pi-gift" style={{ color: "#225349" }} />
      <span>Free</span>
      <span className="te-period-badge">Energy at €0.00/kWh</span>
    </div>

    <div className="te-period-body">
      <div className="te-fields-grid">
        <Field label="Energy fee" unit="€/kWh" fixed>
          <InputNumber
            value={0}
            disabled
            minFractionDigits={2}
            maxFractionDigits={2}
            className="te-input w-full"
          />
        </Field>

        <Field label="Blocking fee" unit="€/h" fixed>
          <InputNumber
            value={0}
            disabled
            minFractionDigits={2}
            maxFractionDigits={2}
            className="te-input w-full"
          />
        </Field>

        <Field label="Activation fee" unit="€" fixed>
          <InputNumber
            value={0}
            disabled
            minFractionDigits={2}
            maxFractionDigits={2}
            className="te-input w-full"
          />
        </Field>
      </div>
    </div>
  </div>
);

export default FreeSection;
